function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import { compareInt } from '../util';
import Results from './results';
import DiscourseResult from './discourse_result';
var STRATEGIES = {
  recent: function recent(result) {
    return -result.id;
  },
  mine: function mine(result) {
    return -result.get('score');
  },
  top: function top(result1, result2) {
    // sort results descending when scores are identical
    if (result1.get('score') === result2.get('score')) {
      if (result1.id > result2.id) {
        return 1;
      } else {
        return -1;
      }
    } else {
      if (result1.get('score') > result2.get('score')) {
        return -1;
      } else {
        return 1;
      }
    }
  },
  netVotes: function netVotes(result1, result2) {
    // Compare by net votes first
    var comparison = compareInt(result1.get('net_votes'), result2.get('net_votes'));

    if (comparison !== 0) {
      return comparison;
    } // Use upvotes as a tie breaker


    comparison = compareInt(result1.get('upvotes'), result2.get('upvotes'));

    if (comparison !== 0) {
      return comparison;
    } else {
      // Use chronological order as the 2nd tie breaker
      return compareInt(result2.id, result1.id);
    }
  },
  netVotesRecentFirst: function netVotesRecentFirst(result1, result2) {
    // Compare by net votes first
    var comparison = compareInt(result1.get('net_votes'), result2.get('net_votes'));

    if (comparison !== 0) {
      return comparison;
    } // Use upvotes as a tie breaker


    comparison = compareInt(result1.get('upvotes'), result2.get('upvotes'));

    if (comparison !== 0) {
      return comparison;
    } else {
      // Use reverse chronological order as the 2nd tie breaker
      return compareInt(result1.id, result2.id);
    }
  }
}; // @namespace Model

var DiscourseResults = /*#__PURE__*/function (_Results) {
  _inheritsLoose(DiscourseResults, _Results);

  function DiscourseResults() {
    return _Results.apply(this, arguments) || this;
  }

  var _proto = DiscourseResults.prototype;

  _proto.changeSort = function changeSort(strategy) {
    this.comparator = this.strategies[strategy];
  };

  _proto.maxUpvotes = function maxUpvotes() {
    return Math.max.apply(Math, this.pluck('upvotes').concat(0));
  };

  _proto.maxDownvotes = function maxDownvotes() {
    return Math.max.apply(Math, this.pluck('downvotes').concat(0));
  };

  _createClass(DiscourseResults, [{
    key: "model",
    get: function get() {
      return DiscourseResult;
    },
    set: function set(value) {}
  }, {
    key: "sortStrategy",
    get: function get() {
      return 'recent';
    }
  }, {
    key: "strategies",
    get: function get() {
      return STRATEGIES;
    }
  }]);

  return DiscourseResults;
}(Results);

export { DiscourseResults as default };